import { getInitialsFromName } from "../../helpers/utilHelper";
import UserAvatar from "./UserAvatar";

type TNotaryInfoProps = {
  notaryInfo: any;
}

const NotaryInfo = ({ notaryInfo }: TNotaryInfoProps) => {

  return <div className="notary-info-box mt-4 mb-4">
    <UserAvatar className='mt-4' size='xl' id={notaryInfo.notaryUserId} image={notaryInfo.notaryPicture} initials={getInitialsFromName(notaryInfo.notaryFullName) ?? ''} />
    <div className="notary-name mt-2">{notaryInfo.notaryFullName}</div>
  </div>
}


export default NotaryInfo;